import React, { useContext } from "react";
import "./Auth.css";
import version from "../Constant/version.json";
import Logo from "../assets/images/karabama-logo.5cf90918.svg";
import { Input, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setUserMobile } from "../Redux/Actions/AuthAction";
import { AuthContext } from "../Api/authReq";
import FormatHelper from "../Helper/FormatHelper";
import lang from "./lang/lang.json";
import { FiPhoneCall } from "react-icons/fi";
// import { toast } from "react-toastify";

const ProLogin = () => {
  const dispatch = useDispatch();
  const mobile = useSelector((state) => state.AuthReducer.userMobile);

  const getMobile = (e) => {
    dispatch(setUserMobile(FormatHelper.toEnglishString(e.target.value)));
  };

  const { proLogin, loading } = useContext(AuthContext);

  return (
    <form onSubmit={proLogin} className="prologin">
      <img src={Logo} alt="karabama logo" />
      <Input
        pattern="[0-9]{11}"
        value={mobile}
        autoFocus
        type="tel"
        onChange={getMobile}
        placeholder={lang.ENTER_YOUR_MOBILE}
        className="prologin-get-number"
        id="prologin_mobile_input"
      />
      <Button
        htmlType="submit"
        loading={loading}
        disabled={mobile === ""}
        className="prologin-submit"
        id="prologin_submit_button"
      >
        {lang.GET_VERIFICATION_CODE}
      </Button>
      <div className="login_support">
        <div>
          در صورتی که تمایل به همکاری با کاراباما دارید، برای ثبت‌نام بر روی
          گزینه زیر کلیک کنید.
        </div>
        <a
          href="https://portal.karabaman.ir/web/technician/?utm_campaign=brand-recall-1402&gclid=Cj0KCQjw2ou2BhCCARIsANAwM2F0Vmo9UAoRk2ZDlJIPecZm0eazu1g8Z5USdJXFzwa3fMw0iLnL830aAoZ4EALw_wcB&kwd_id=kwd-837201826043"
          target="_blank"
          rel="noreferrer"
        >
          ثبت نام
        </a>
        <a href="tel:02141259100">
          <span></span>
          <FiPhoneCall />
        </a>
      </div>
      <span
        style={{
          marginTop: "20px",
          color: "rgba(255,255,255,.7)",
          fontSize: 14,
        }}
      >
        {lang.VERSION} {FormatHelper.toPersianString(version.version)}
      </span>
    </form>
  );
};
export default ProLogin;
